<script setup>
import FormHeader from '@/Components/FormHeader.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { __ } from '@/app';
import LayoutNew from '@/Layouts/LayoutNew.vue';
import SubmitButton from '@/Components/SubmitButton.vue';


const form = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms: false,
});

const submit = () => {
    form.post(route('register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <LayoutNew>
        <Head v-bind:title="__('Zarejestrować się')" />
        
        <div style="max-width: 450px; width: 100%;">
            <FormHeader v-bind:title="__( 'Zarejestrować się' )"/>

            <div>
                <BreezeValidationErrors class="alert alert-danger" />
                
                <form @submit.prevent="submit">
                    <div class="mb-2">
                        <label for="name" class="form-label" v-text="__( 'Imię' )"/>
                        <BreezeInput v-bind:placeholder="__('Wpisz swoje imię')" id="name" type="name" class="form-control" v-model="form.name" required autofocus autocomplete="username" />
                        <div class="error" id="nameError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="email" class="form-label" v-text="__( 'Adres Email' )"/>
                        <BreezeInput v-bind:placeholder="__('Wprowadź swój adres e-mail')" id="email" type="email" class="form-control" v-model="form.email" required autofocus autocomplete="username" />
                        <div class="error" id="emailError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="password" class="form-label" v-text="__('Hasło')"/>
                        <BreezeInput v-bind:placeholder="__('Wprowadź swoje hasło')" id="password" type="password" v-model="form.password" required autocomplete="current-password" />
                        <div class="error" id="passwordError"></div>
                    </div>
                    <div class="mb-2">
                        <label for="password_confirmation" class="form-label" v-text="__('Potwierdź hasło')"/>
                        <BreezeInput v-bind:placeholder="__('Potwierdź swoje hasło')" id="password_confirmation" type="password" v-model="form.password_confirmation" required autocomplete="current-password" />
                        <div class="error" id="passwordError"></div>
                    </div>
                    
                    <SubmitButton v-bind:text="__( 'Zarejestrować się' )"/>
                    
                    <div class="text-center">
                        <a class="" :href="route('login')" v-text="__( 'Jesteś zarejestrowany?' )"/>
                    </div>
                    
                </form>
            </div>
        </div>
    
    </LayoutNew>
</template>
